import { useEffect } from 'react';
import { resolveBackgroundThemeId } from '@/config/appTheme';
import { useVFXConfigContext } from '@/features/vfx/contexts/VFXConfigContext';

/**
 * Mirrors the active admin background theme onto <html data-bg-theme="N">,
 * so the v2 surface tokens (src/styles/tokens.css) pick up the theme tint.
 */
export function useBackgroundThemeAttr(): void {
  const { state } = useVFXConfigContext();
  const config = state.config as Parameters<typeof resolveBackgroundThemeId>[0];
  const themeId = resolveBackgroundThemeId(config);

  useEffect(() => {
    document.documentElement.dataset.bgTheme = String(themeId);
  }, [themeId]);
}

/** Renders nothing; mount once inside VFXConfigProvider. */
export function BackgroundThemeSync(): null {
  useBackgroundThemeAttr();
  return null;
}
